import AlertMsg from "./AlertMsg";

export default function displayAlertMsg(message){
    return message?.length > 0 ?
        <AlertMsg message={message}/> :
        <AlertMsg />
}